import { useQueryCacheUpdater } from "@/hooks/useQueryCacheUpdater";
import { MutationFunction } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useToast } from "@/components/ui/use-toast";
import { Module, PATH_DEFAULT_STORE_PROJECT_ASSIGNEES } from "@/constants";
import { ApiError } from "@/services/api";
import { DefaultStoreProjectAssigneesService } from "@/services/defaultStoreProjectAssignees";
import { useDefaultStoreProjectAssigneeId } from "@/modules/defaultStoreProjectAssignees/hooks/useDefaultStoreProjectAssigneeId";
import { useMutationWithErrorHandling } from "@/hooks/useMutationWithErrorHandling";
import { generatePath, useNavigate } from "react-router-dom";

export const useDeleteDefaultStoreProjectAssignee = () => {
  const { t } = useTranslation();
  const { toast } = useToast();
  const navigate = useNavigate();
  const id = useDefaultStoreProjectAssigneeId();
  const { invalidateListQuery } = useQueryCacheUpdater(
    Module.DefaultStoreProjectAssignees,
  );

  const mutationFn: MutationFunction<void, string> = async () => {
    const response = await DefaultStoreProjectAssigneesService.delete(id);
    return response;
  };

  const mutation = useMutationWithErrorHandling<
    unknown,
    ApiError,
    string,
    unknown
  >({
    mutationFn,
    onSuccess: () => {
      toast({
        title: t("defaultStoreProjectAssignees.success.delete"),
      });
      invalidateListQuery();
      navigate(generatePath(PATH_DEFAULT_STORE_PROJECT_ASSIGNEES));
    },
    errorTitle: t("defaultStoreProjectAssignees.errors.delete"),
  });

  return mutation;
};
